export const getAssociatedObjectEdges = associatedObjects => {
  if (!associatedObjects) {
    return [];
  }
  return associatedObjects.primaryEdge ? [associatedObjects.primaryEdge, ...associatedObjects.secondaryEdges] : associatedObjects.secondaryEdges;
};